import update from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/constants';
import hasPath from 'ramda/src/hasPath';
import ActionTypes from 'constants/ActionTypes';
import { KEYWORD_GAP_COLUMNS } from 'constants/keywordColumns';

const initialState = {
    isDropdownVisible: false,
    visible: {
        [KEYWORD_GAP_COLUMNS.CONTENT_TYPE]: true,
        [KEYWORD_GAP_COLUMNS.SEARCH_INTENT]: true,
        [KEYWORD_GAP_COLUMNS.SERP_FEATURES]: true,
        [KEYWORD_GAP_COLUMNS.KW_OPPORTUNITIES]: true,
        [KEYWORD_GAP_COLUMNS.AVG_SEARCH_VOLUME]: true,
        // [KEYWORD_GAP_COLUMNS.SERP_POSITION]: true,
        [KEYWORD_GAP_COLUMNS.MSV_TRENDS]: true,
        [KEYWORD_GAP_COLUMNS.CPC]: true,
        [KEYWORD_GAP_COLUMNS.PPC]: true,
        [KEYWORD_GAP_COLUMNS.KEYWORD_DIFFICULTY]: true,
    }
};

const KEYWORD_GAP_COLUMNS_ARRAY = Object.values(KEYWORD_GAP_COLUMNS);

const keywordGapColumnsSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_KEYWORD_GAP_COLUMNS_SETTINGS_CHANGE: {
            if (!KEYWORD_GAP_COLUMNS_ARRAY.includes(action.payload.column) && !action.payload.column.startsWith('competitor-')) {
                // just prevent from incorrect usage
                return state
            }

            return update(state, {
                visible: {
                    [action.payload.column]: {
                        $set: action.payload.value,
                    }
                }
            });
        }
        case ActionTypes.UI_KEYWORD_GAP_COLUMNS_SETTINGS_DROPDOWN_VISIBLE: {
            return update(state, {
                isDropdownVisible: {
                    $set: action.payload,
                },
            });
        }
        case ActionTypes.DATA_KEYWORD_GAP_RESULTS_RECEIVED: {
            const payload = action.payload;
            const params = payload.params || {};

            // Pages mode echoes domain/competitors as null (target lives in
            // excludePages/pages); resolve per mode to avoid null.forEach.
            const mode = params.mode === 'pages' ? 'pages' : 'domains';
            const ownTarget = mode === 'pages'
                ? params.excludePages || ''
                : params.domain || '';
            const competitorsList = mode === 'pages'
                ? (payload.results || [])
                    .map((r) => r && r.domain)
                    .filter((d) => typeof d === 'string' && d.length > 0)
                : params.competitors || [];

            const resultsObject = {};
            if (ownTarget) {
                resultsObject[`competitor-${ownTarget}-visits`] = true;
                resultsObject[`competitor-${ownTarget}-rank`] = true;
            }
            competitorsList.forEach((competitor) => {
                resultsObject[`competitor-${competitor}-visits`] = true
                resultsObject[`competitor-${competitor}-rank`] = true
            });
            const oldSettings = Object.keys(state.visible).filter(key => !key.startsWith('competitor-')).reduce((obj, key) => {
                obj[key] = state.visible[key];
                return obj;
            }, {});

            return update(state, {
                visible: {
                    $set: {
                        ...oldSettings,
                        ...resultsObject
                    },
                },
            });
        }
        case REHYDRATE: {
            let newVisible = initialState.visible

            if (hasPath(['ui', 'columnsSettings', 'keywordGap'], action.payload)) {
                const savedState = action.payload.ui.columnsSettings.keywordGap
                newVisible = savedState.visible

                // Set default values for new columns if they don't exist
                KEYWORD_GAP_COLUMNS_ARRAY.forEach(column => {
                    if (newVisible[column] === undefined) {
                        newVisible[column] = initialState.visible[column];
                    }
                });
            }

            return update(state, {
                visible: {
                    $set: newVisible,
                }
            });
        }
        default: {
            return state;
        }
    }
};

export default keywordGapColumnsSettingsReducer;
